export const listTemplatesDashboard = `query ListTemplates(
  $filter: ModelTemplateFilterInput
  $nextToken: String
) {
  listTemplates(filter: $filter, nextToken: $nextToken) {
    items {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
    }
    nextToken
  }
}
`;

export const getBundleWithDocs = /* GraphQL */ `
  query GetBundle($id: ID!, $nextToken: String) {
    getBundle(id: $id) {
      id
      name
      description
      status
      fileUrl
      type
      createdAt
      updatedAt
      bundleVersion
      flowTemplateId
      template {
        id
        name
      }
      tags
      flowId
      flow
      zipFile
      document (nextToken: $nextToken) {
        nextToken
        items {
          description
          fileUrl
          flowId
          id
          name
          status
          subgroups
          updatedAt
          type
          flow
        }
      }
    }
  }
`;

export const customGetDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        signaturesPositions {
          pageNumber
          boundingRect {
            x1
            x2
            y1
            y2
            width
            height
          }
          rects
        }
        skip,
        addToCertifiedEvidence
      }
      principal {
        name
        path
        description
        signaturesPositions {
          pageNumber
          boundingRect {
            x1
            x2
            y1
            y2
            width
            height
          }
          rects
        }
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
    }
  }
`;
